import React from 'react';
import styles from './Tools.module.css';

const Tools = () => {
  return (
    <section className={styles.tools}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Практические инструменты для успешного года</h2>
        <div className={styles.toolsGrid}>
          <div className={styles.tool}>
            <div className={styles.imageWrapper}>
              <img 
                src="https://strategy.annavision.me/wp-content/uploads/2025/12/a22e6f91b87a867bdeae454b678ccf06_1766902148-1.png" 
                alt="Древний китайский инструмент времени - Денежные часы" 
                className={styles.toolImage}
              />
            </div>
            <h3 className={styles.title}>Денежные часы</h3>
            <p className={styles.description}>
              Детальная инструкция о том, в какое время суток вам нужно совершать транзакции, чтобы "разогреть" денежную энергию и стать более знакомой для денег. Это не абстрактная техника, а конкретные часы для вашего персонального расчета.
            </p>
          </div>
          <div className={styles.tool}>
            <div className={styles.imageWrapper}>
              <img 
                src="https://strategy.annavision.me/wp-content/uploads/2025/12/186a607846e79f559137df8804660cb3_1766902179-1.png" 
                alt="Визуализация денежной энергии - Грабитель богатства" 
                className={styles.toolImage}
              />
            </div>
            <h3 className={styles.title}>Грабитель богатства</h3>
            <p className={styles.description}>
              Техника работы с определенными днями года. В вашем прогнозе будут указаны конкретные даты, когда максимально эффективно делать крупные покупки, инвестиции, финансовые операции.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tools;

